import { Handle, Position } from '@xyflow/react'
import { isFired } from './useFiredFlash'

/**
 * OnConstruct event node (ENG-981 rework) — Unreal construction-script
 * analog: fires whenever the event graph is (re)constructed, i.e. after
 * graph hydration AND after every applied editor edit — editor time AND
 * play time, not just once at play start like `beginPlay`. Visual treatment
 * copied from BeginPlayNode.jsx (same shell, same "Events" family) since
 * this is its sibling in every mechanical respect: no exec input (events
 * are always the start of a chain), unique per canvas / per group.
 *
 * This is the missing primitive that let `headTrackedCamera` become an
 * ordinary exec node instead of a declarative config node with no wires:
 * wire this into it to get "armed at load and re-applied on every editor
 * edit" (live tuning through the wire) — see EventRuntime.js's
 * onConstruct dispatch wiring (src/lib/onConstructDispatch.js) and
 * CameraNodes.jsx's HeadTrackedCameraNode.
 */
export function OnConstructNode({ selected, data }) {
  const fired = isFired(data)
  return (
    <div
      title="Fires once the avatar finishes loading, and again after every editor edit — the app's one entry event (beginPlay merged into this node)."
      style={{
        background: selected ? '#280e0e' : '#1a0808',
        border: `2px solid ${fired ? '#ffcc44' : selected ? '#ff5050' : '#8b1a1a'}`,
        borderRadius: 6,
        minWidth: 200,
        fontFamily: 'var(--m-font)',
        overflow: 'hidden',
        boxShadow: fired ? '0 0 14px rgba(255,200,40,0.6)' : selected ? '0 0 12px rgba(255,60,60,0.2)' : 'none',
      }}>
      {/* Header bar */}
      <div style={{
        background: '#5a1010',
        padding: '6px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}>
        <span style={{ fontSize: 13 }}>▶</span>
        <span style={{ color: '#ff9090', fontWeight: 'bold', fontSize: 11, letterSpacing: 0.5 }}>
          Event On Construct
        </span>
      </div>

      {/* Body */}
      <div style={{ padding: '8px 12px', color: '#804040', fontSize: 10 }}>
        Fires once the avatar loads, and after every editor edit.
      </div>

      {/* Exec out — white square handle like Unreal */}
      <Handle
        type="source"
        position={Position.Right}
        id="execOut"
        style={{
          background: '#ddd',
          width: 12, height: 12,
          borderRadius: 2,
          border: '2px solid #aaa',
        }}
      />
    </div>
  )
}
